type PermissionValues = 'dashboard.admin';

export class DashboardPermission {
  // public static readonly viewUsersPermission: PermissionValues = 'users.view';
  public static readonly admin: PermissionValues = 'dashboard.admin';
}
